<ng-select
  [ngClass]="{ 'form-control-sm': small }"
  [items]="data"
  bindValue="id"
  bindLabel="regione"
  [(ngModel)]="state"
  (ngModelChange)="onChange.emit($event)"
></ng-select>
